import React, { useEffect } from 'react';
import throttle from 'lodash/throttle';
import classnames from 'classnames';
import { Spinner } from 'react-bootstrap';
import styles from './infiniteScroll.module.scss';
import { isScrollAtBottom } from './infiniteScroll.utils';

export interface InfiniteScrollProps {
  callback: () => void;
  scrollableTarget?: string;
  scrollThreshold?: number;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

const InfiniteScroll = ({
  callback,
  scrollableTarget,
  scrollThreshold,
  className,
  isLoading,
  disabled,
}: InfiniteScrollProps) => {
  useEffect(() => {
    const throttledOnScrollListener = throttle((e) => onScrollListener(e), 500);
    const target = scrollableTarget
      ? document.getElementById(scrollableTarget)
      : window;
    target && target.addEventListener('scroll', throttledOnScrollListener);
    return () => {
      target && target.removeEventListener('scroll', throttledOnScrollListener);
    };
  }, [scrollableTarget, isLoading, disabled]);

  const onScrollListener = (event: MouseEvent): void => {
    if (isLoading || disabled) {
      return;
    }

    let target: HTMLElement = event.target as HTMLElement;
    if (!scrollableTarget) {
      target = document.documentElement.scrollTop
        ? document.documentElement
        : document.body;
    }

    const isAtBottom = isScrollAtBottom(target, scrollThreshold);
    if (isAtBottom) {
      callback?.();
    }
  };

  if (disabled) {
    return null;
  }

  return (
    <div className={`infinite-scroll-component ${className || ''}`}>
      {isLoading && (
        <div className={classnames(styles.spinnerContainer)}>
          <Spinner animation="border" aria-label="loading" />
        </div>
      )}
    </div>
  );
};

export default InfiniteScroll;
